import { createContext, useContext } from 'react';
import type { Plan } from '@/services/frandroid-api';

export interface PlansContextValue {
  mobilePlans: Plan[];
  internetPlans: Plan[];
}

export const PlansContext = createContext<PlansContextValue | null>(null);

export function usePlansContext(): PlansContextValue | null {
  return useContext(PlansContext);
}
